@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.rides

data class RideRouteDto(
    val geometry: String?,
    val totalDistanceInKm: Double,
    val totalDurationInMins: Double,
)